import { render, staticRenderFns } from "./EarningPage.vue?vue&type=template&id=2bd5a1fc&scoped=true"
import script from "./EarningPage.vue?vue&type=script&lang=ts"
export * from "./EarningPage.vue?vue&type=script&lang=ts"
import style0 from "./EarningPage.vue?vue&type=style&index=0&id=2bd5a1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5a1fc",
  null
  
)

export default component.exports